<template>
	<div>
		<BaseTable
			:actions="{
				add: false,
				import: false,
				export: false,
				operation: false,
			}"
			:selection="false"
			:data="data"
			:columns="columns"
			:total="total"
			:pageNum="pageNum"
			:pageSize="pageSize">
			<template slot="header-left">
				<el-button size="small" icon="el-icon-plus" type="primary" @click="handerAdd">新增资源</el-button>
				<el-button size="small" icon="el-icon-download" @click="handerExport">导出资源</el-button>
			</template>
			<template #resourceType="{ row }">
				<el-tag :type="ResourceType[row.resourceType] || 'default'" size="small">
					{{ $menu.getLabel('ResourceType', row.resourceType) }}
				</el-tag>
			</template>
			<template #rentPrice="{ row }">
				{{ `¥${row.rentPrice}/㎡/月` }}
			</template>

			<template #currentStatus="{ row }">
				<el-tag :type="RentalStatus[row.currentStatus] || 'default'" size="small">
					{{ $menu.getLabel('RentalStatus', row.currentStatus) }}
				</el-tag>
			</template>
		</BaseTable>
	</div>
</template>

<script>
	import { ResourceType, RentalStatus } from '@/utils/meunType.js';
	export default {
		name: 'AssetLedgerRelatedResource',
		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				ResourceType,
				RentalStatus,
				total: 0,
				pageNum: 1,
				pageSize: 10,
				columns: [
					{ prop: 'resourceNo', label: '资源编号' },
					{ prop: 'resourceName', label: '资源名称' },
					{ prop: 'resourceType', label: '资源类型', slot: 'resourceType' },
					{ prop: 'area', label: '面积(㎡)' },
					{ prop: 'currentStatus', label: '资源状态', slot: 'resourceType' },
					{ prop: 'rentPrice', label: '租金单价(元/㎡/月)', width: '150px', slot: 'rentPrice' },
				],
			};
		},
		methods: {
			handerAdd() {},
			handerExport() {},
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}
</style>
